import { Swords } from '../../components/ui/icons';

export function TermRow({
  Icon,
  title,
  sub
}: {
  Icon: typeof Swords;
  title: string;
  sub: string;
}) {
  return (
    <div className="flex items-center gap-[13px] rounded-2xl border border-black/5 bg-card p-4 shadow-tile">
      <div className="grid h-10 w-10 shrink-0 place-items-center rounded-[12px] bg-fill">
        <Icon width={20} height={20} strokeWidth={2} className="text-ink" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[13px] font-extrabold tracking-snug text-ink">{title}</div>
        <div className="truncate text-[11px] font-medium text-ink2">{sub}</div>
      </div>
    </div>
  );
}
